import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  MatDialog} from '@angular/material';
import 'rxjs/add/observable/of';
import { OrderService } from '../../services/order/order.service';
import { TokenStorage } from 'src/app/auth/token.storage';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {
  datefilter: string
  selectedVal: string
  mapView: boolean = false;
  isTenantDiag: boolean = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();

  constructor(
    token: TokenStorage,
    private orderService: OrderService
  ) {
    if (token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
      orderService.notifyChildOfOrderTypeChange('sample');
    }  
  }

  ngOnInit() {
    this.selectedVal = '1week';
  }

  onValChange() {
    this.notifyParent.emit('e');
  }

  onOrderTypeChange(orderType: string) {
    this.orderService.notifyChildOfOrderTypeChange(orderType);
  }
}

